import { KEY_ESCAPE } from "constants/keyboardKeys";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { collapseChat } from "store/slices/chatExpanded";
import { RootState } from "store/store";

const OPEN_OVERLAY_SELECTOR = [
  '[role="dialog"][data-state="open"]',
  '[role="alertdialog"][data-state="open"]',
  '[role="menu"][data-state="open"]',
  '[role="listbox"][data-state="open"]',
  '[data-radix-popper-content-wrapper] [data-state="open"]',
].join(", ");

export const useCollapseChatOnEscape = (): void => {
  const dispatch = useDispatch();
  const isExpanded = useSelector(
    (state: RootState) => state.chatExpanded.isExpanded
  );

  useEffect(() => {
    if (!isExpanded) return undefined;

    const handleKeyDown = (event: KeyboardEvent) => {
      if (event.key !== KEY_ESCAPE) return;
      if (document.querySelector(OPEN_OVERLAY_SELECTOR)) return;

      dispatch(collapseChat());
    };

    document.addEventListener("keydown", handleKeyDown, true);

    return () => document.removeEventListener("keydown", handleKeyDown, true);
  }, [isExpanded, dispatch]);
};
